define('constants/scheduledReportDeliveryFrequencyConstants',[], function() {
    return {
        Unknown: "0",
        Daily: "1",
        Weekly: "2",
        Monthly: "3"
    };
});
